// pdf.js 6 fetches its JBIG2/JPX/ICC decoders as separate wasm files instead of bundling them in the worker
export const PDFJS_WASM_ROUTE = "/pdfjs-wasm/";
